/* tslint:disable */
/* eslint-disable */
/**
 * crm-screener
 * crm-screener
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { CreatePccPatientResponse } from './CreatePccPatientResponse';
import {
    CreatePccPatientResponseFromJSON,
    CreatePccPatientResponseFromJSONTyped,
    CreatePccPatientResponseToJSON,
    CreatePccPatientResponseToJSONTyped,
} from './CreatePccPatientResponse';

/**
 * 
 * @export
 * @interface CreatePccPatient201Response
 */
export interface CreatePccPatient201Response {
    /**
     * 
     */
    data?: CreatePccPatientResponse;
}

/**
 * Check if a given object implements the CreatePccPatient201Response interface.
 */
export function instanceOfCreatePccPatient201Response(value: object): value is CreatePccPatient201Response {
    return true;
}

export function CreatePccPatient201ResponseFromJSON(json: any): CreatePccPatient201Response {
    return CreatePccPatient201ResponseFromJSONTyped(json, false);
}

export function CreatePccPatient201ResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): CreatePccPatient201Response {
    if (json == null) {
        return json;
    }
    return {
        
        'data': json['data'] == null ? undefined : CreatePccPatientResponseFromJSON(json['data']),
    };
}

export function CreatePccPatient201ResponseToJSON(json: any): CreatePccPatient201Response {
    return CreatePccPatient201ResponseToJSONTyped(json, false);
}

export function CreatePccPatient201ResponseToJSONTyped(value?: CreatePccPatient201Response | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'data': CreatePccPatientResponseToJSON(value['data']),
    };
}

